import IAppLogger from '@app/lib/IAppLogger';
import { audioDevicesState } from '../audioDevicesState';
import { AudioDevicesChangedPayload } from '../types';
import { webPhoneEventNames } from '../constants/events';

/**
 * Handles the `webphone:audio-devices-changed` event emitted by the webphone MFE
 * when a device switch succeeds (either user-initiated or automatic hardware fallback).
 *
 * Updates active device IDs in {@link audioDevicesState} and clears any previous errors.
 */
const handleAudioDevicesChanged = (
  payload: AudioDevicesChangedPayload,
  logger: IAppLogger,
): void => {
  const { audioInput, audioOutput, ringOutput } = payload;

  logger.debug(webPhoneEventNames.audioDevicesChanged, {
    audioInputDeviceId: audioInput.deviceId,
    audioOutputDeviceId: audioOutput.deviceId,
    ringOutputDeviceId: ringOutput.deviceId,
  });

  audioDevicesState.currentInputDeviceId = audioInput.deviceId;
  audioDevicesState.currentOutputDeviceId = audioOutput.deviceId;
  audioDevicesState.currentRingDeviceId = ringOutput.deviceId;
  audioDevicesState.lastSetDevicesError = null;
};

export default handleAudioDevicesChanged;
